import { EventsInformationActionTypes } from './action-types';
import { EventInformation } from 'models';

export const requestEventsInformation = (coopId: string) =>
  ({
    type: EventsInformationActionTypes.REQUEST_EVENTS_INFORMATION,
    payload: coopId,
  } as const);

export const requestEventInformationSuccess = (
  eventsInformation: EventInformation[]
) =>
  ({
    type: EventsInformationActionTypes.REQUEST_EVENT_INFORMATION_SUCCESS,
    payload: eventsInformation,
  } as const);

export const requestEventInformationFailed = () =>
  ({
    type: EventsInformationActionTypes.REQUEST_EVENT_INFORMATION_FAILED,
  } as const);

export const setEventInformationSearchTerm = (searchTerm: string) =>
  ({
    type: EventsInformationActionTypes.SET_SEARCH_TERM,
    payload: searchTerm,
  } as const);
